// File: src/components/Footer.tsx
import React from "react";
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  // SEO: Local Business Schema for Footer
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "HealthAndBeautyBusiness",
    "name": "AyushVatika",
    "image": "https://www.ayushvatika.com/logo.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Sector 62",
      "addressLocality": "Noida",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "201301",
      "addressCountry": "IN"
    },
    "priceRange": "₹₹",
    "telephone": "+91-1234567890"
  };

  return (
    <footer className="bg-[#f5f5dc] text-[#4a6b2e] py-10 relative overflow-hidden font-bold">
      {/* Schema injected via script tag for sitewide visibility */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>

      <div className="max-w-6xl mx-auto px-7 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-10 border-b border-gray-300">
          
          {/* Column 1: Follow & Contact */}
          <div className="flex flex-col items-start space-y-4">
            <h3 className="text-sm font-bold mb-2 text-[#008000]">FOLLOW AYUSHVATIKA</h3>
            <div className="flex space-x-4 text-xl">
              <a href="#" aria-label="Follow AyushVatika on Facebook" className="hover:text-[#006400] transition-colors"><FaFacebookF /></a>
              <a href="#" aria-label="Follow AyushVatika on Instagram" className="hover:text-[#006400] transition-colors"><FaInstagram /></a>
            </div>
            <a href="/contact-us">
  <h3 className="text-sm font-bold mt-4 mb-2 text-[#008000] hover:underline cursor-pointer">
    CONTACT US
  </h3>
</a>

            <p className="text-xs">
              <a href="mailto:info@ayushvatika.com" className="hover:underline text-[#008000]">info@ayushvatika.com</a>
            </p>
            <p className="text-xs text-gray-700">
              Noida, Uttar Pradesh, India
            </p>
          </div>

          {/* Column 2: Herbs and Service */}
          <div className="flex flex-col items-start space-y-4">
            <h3 className="text-sm font-bold mb-2 text-[#008000]">AYURVEDIC PRODUCTS</h3>
            <ul className="text-sm space-y-2">
              <li><Link to="/all-products" className="text-gray-700 hover:text-green-700">Shop All Herbs</Link></li>
              <li><Link to="/blog" className="hover:underline text-gray-700">Ayurveda Blog</Link></li>
              {/* <li><Link to="/category/skincare" className="text-gray-700 hover:text-green-700">Herbal Skincare</Link></li> */}
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div className="flex flex-col items-start space-y-4">
            <h3 className="text-sm font-bold mb-2 text-[#008000]">QUICK LINKS</h3>
            <ul className="text-sm space-y-2">
              <li><Link to="/about" className="hover:underline text-gray-700">About AyushVatika</Link></li>
              
              <li><Link to="/settings" className="hover:underline text-gray-700">Track Order</Link></li>
              {/* <li><Link to="/myorder" className="hover:underline text-gray-700">Returns & Refunds</Link></li> */}
            </ul>
          </div>

          {/* Column 4: Newsletter */}
          <div className="flex flex-col items-start space-y-4">
            <h3 className="text-sm mb-2 text-[#008000]">JOIN OUR HERBAL FAMILY</h3>
            <p className="text-sm text-gray-700">
              Subscribe for exclusive offers on Ayurvedic medicines and health tips.
            </p>
            <div className="flex space-x-4 mt-4">
              <img src="https://clipart-library.com/images_k/certified-stamp-transparent/certified-stamp-transparent-16.jpg" alt="Certified Organic Ayurveda" className="h-6 w-auto" />
              <img src="https://www.vvd.in/wp-content/uploads/2024/07/vvd-ayush-logo1.png" alt="Ayush Ministry Certified" className="h-6 w-auto" />
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="text-center text-[14px] text-[#008000] mb-10 mt-6 space-y-2">
          <p className="max-w-5xl mx-auto leading-relaxed">
            AyushVatika products are 100% herbal. Information here is for educational purposes. Consult a Vaidya for medical advice.
          </p>
          <p className="max-w-5xl mx-auto">
            © {new Date().getFullYear()} AyushVatika. Made with 🌿 in India. 
            <Link to="/privacy" className="hover:underline text-[#006400] ml-2">Privacy Policy</Link> | 
            <Link to="/term&condition" className="hover:underline text-[#006400] ml-2">Terms of Service</Link>
          </p>
        </div>
      </div>
      <div className="relative w-full h-20 bg-[#4a6b2e]"></div>
    </footer>
  );
};

export default Footer;